import { render, staticRenderFns } from "./SamsungDarkBanner.vue?vue&type=template&id=18360f3e&scoped=true"
import script from "./SamsungDarkBanner.vue?vue&type=script&lang=js"
export * from "./SamsungDarkBanner.vue?vue&type=script&lang=js"
import style0 from "./SamsungDarkBanner.vue?vue&type=style&index=0&id=18360f3e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18360f3e",
  null
  
)

export default component.exports